import React from 'react'
import { Box, Flex, Text } from 'rebass'

import { RosterEntry, Team } from '../../../types/graphql'
import { rawNumPlayers } from '../../../utils/sportUtils'
import { CustomInput } from '../../atoms/FormPieces'
import { CustomSelect } from '../../atoms/Select'
import Table from '../../atoms/Table'

interface ReportingProps {
  team: Team
  isHomeTeam: boolean
  handleChange: (e: React.ChangeEvent, isHomeTeam: boolean, i: number) => void
  valorantAgents: Array<string>
  teamResults: { [key: number]: { [key: string]: string } }
  recordScore: (value: string) => void
  score: string
}

const ValorantReportingTable = ({
  team,
  isHomeTeam,
  handleChange,
  valorantAgents,
  teamResults,
  recordScore,
  score,
}: ReportingProps) => {
  const num = Number(rawNumPlayers(team.sportSlug))

  const handleScore = (event: React.SyntheticEvent) => {
    const value = (event as any).target.value

    recordScore(value)
  }

  return (
    <>
      <Box width={[1, 1, 1, 1 / 2]} mt={5} px={[0, 0, 0, 2]} mb={[4, 4, 4, 0]}>
        <Flex alignItems="center" justifyContent="space-between">
          <h3>{team.truncatedName}</h3>
          <CustomInput type="number" value={parseInt(score)} onChange={handleScore} width="25%" />
        </Flex>
        <Box mt={4}>
          <Table
            bodyBackgroundColor="backgroundgray"
            thpadding="0.8rem .75rem 0.7rem"
            tdpadding=".8rem .5rem"
            align="left"
          >
            <colgroup>
              <col span={1} style={{ width: '60%' }} />
              <col span={1} style={{ width: '40%' }} />
            </colgroup>

            <thead>
              <tr>
                <th>
                  <Text color="white">
                    <h6>starting player</h6>
                  </Text>
                </th>
                <th>
                  <Text color="white">
                    <h6>Pick</h6>
                  </Text>
                </th>
              </tr>
            </thead>
            <tbody>
              {[...Array(num)].map((el, i: number) => (
                <tr key={i}>
                  <td>
                    <CustomSelect
                      key={teamResults[i].name}
                      onChange={e => {
                        handleChange(e, isHomeTeam, i)
                      }}
                      value={teamResults[i].name}
                      name={'name'}
                    >
                      {team.activeRosterEntries &&
                        team.activeRosterEntries.map((entry: RosterEntry) => (
                          <option key={entry.id}>{entry.player && entry.player.username}</option>
                        ))}
                    </CustomSelect>
                  </td>
                  <td>
                    <CustomSelect
                      key={teamResults[i].pick}
                      onChange={e => {
                        handleChange(e, isHomeTeam, i)
                      }}
                      value={teamResults[i].pick}
                      name={'pick'}
                    >
                      {valorantAgents.length ? (
                        valorantAgents.map((agent: string) => <option key={agent}>{agent}</option>)
                      ) : (
                        <option>{teamResults[i].pick}</option>
                      )}
                    </CustomSelect>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Box>
      </Box>
    </>
  )
}
export default ValorantReportingTable
